export var TaxIncomeType;
(function (TaxIncomeType) {
    TaxIncomeType["Employment40_1"] = "EMPLOYMENT_40_1";
    TaxIncomeType["Freelance40_8"] = "FREELANCE_40_8";
})(TaxIncomeType || (TaxIncomeType = {}));
//# sourceMappingURL=tax-income-type.enum.js.map